'use client';

import ErrorComponent from '@components/ErrorComponent/ErrorComponent';
import { useEffect } from 'react';

export default function GlobalError({ error, reset }) {
  useEffect(() => {
    // 1) Log to console so you can see it in your browser’s console.
    console.error('Unhandled client error:', error);
    // 2) Send to your logging service:
    // Sentry.captureException(error);
    // LogRocket.track(error);
  }, [error]);

  return (
    <div style={{ padding: 20 }}>
      <ErrorComponent errorMsg={error.message}/>
    </div>
  );
}
